import { getUpdateStockMerchant, postUploadFileSyncStockMerchant, syncStockMerchant } from '../../utils/api';
import { FAILED, LOADING, SUCCESS } from './constants';

export function loadingAction(isLoading, key, data = {}) {
  return { type: LOADING, data, isLoading, key };
}

export function failedAction(message, key, data = {}) {
  return { type: FAILED, data, message, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}

export const fetchUpdateStockMerchant = (nextPage, search) => {
  return async (dispatch, getState) => {
    const { totalPage } = getState().updateStockMerchant.dataUpdateStock.meta;
    let dataList  = [];
    if (nextPage > 1 && nextPage > totalPage) {
      return;
    }
    const key = 'UpdateStock';
    try {
      if (nextPage !== 1 && nextPage !== '1') {
        dataList = getState().updateStockMerchant.dataUpdateStock.data;
      }
      dispatch(loadingAction(true, key));
      const params = { page: nextPage, size: 100, search };

      let { data, meta } = await getUpdateStockMerchant(params);
      dispatch(successAction({ data: [ ...dataList, ...data] , meta }, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export function fetchSyncStockMerchant(id, callback = () => {}) {
  return async (dispatch) => {
    const key = 'SyncUpdateStock';
    try {
      dispatch(loadingAction(true, key, id ));
      callback();
      const { success, data, message } = await syncStockMerchant(id);
      dispatch(successAction({ data, success, message, id }, key));
    } catch (error) {
      dispatch(failedAction(error.message, key, error));
    }
  };
}

export function uploadStockMerchant(payload, callback = () => {}) {
  return async (dispatch, getState) => {
    const key = 'UploadStock';

    if (getState().updateStockMerchant?.isLoadingUploadStock) {
      return;
    }

    try {
      dispatch(loadingAction(true, key));
      callback();
      const bodyFormData = new FormData();
      bodyFormData.set('type', payload.type);

      for (let [key, value] of payload.file) {
        bodyFormData.append(key, value);
      }
      const { success, data } = await postUploadFileSyncStockMerchant(bodyFormData);
      dispatch(successAction({ data, success }, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
}
